/**
 * Regra "quem responde" da LISTA de conversas, uma so para os 5 inboxes
 * (DIV-31, 2026-10-20).
 *
 * Espelha `services/autopilot_scope.agent_answers` do backend para o que a
 * lista sabe: modo do agente, lista de contatos, bloqueados, pausa por canal
 * e o carimbo `autopilot_since` (regra "so novos": contato que nasceu antes
 * do carimbo fica fora no modo all/scheduled). Responsavel humano e handoff
 * sao decididos antes, pelo chamador (como o cabecalho e a ficha fazem).
 *
 * As 3 listas (QR, Business e o shell compartilhado) chamam esta funcao; o
 * teste estatico garante que nenhuma reimplementa a regra.
 */
export const ACTIVE_MODES = ['all', 'scheduled'];

const sameKey = (a, b) => String(a || '').trim() === String(b || '').trim();

/** Contato nasceu antes do carimbo? Sem data de um dos lados, nao afirma. */
export function predatesSince(createdAt, since) {
  if (!createdAt || !since) return false;
  const c = new Date(createdAt).getTime();
  const s = new Date(since).getTime();
  if (Number.isNaN(c) || Number.isNaN(s)) return false;
  return c < s;
}

/** Data de criacao da conversa, no campo que cada canal usa. */
export function createdAtOf(chat) {
  if (!chat) return null;
  return chat.created_at || chat._created_at || chat.createdAt || null;
}

/**
 * @param {object} cfg  { mode, contacts, blocked, since, channelPaused }
 * @param {object} chat { ref, createdAt }  ref = chave do contato (telefone ou opaca)
 */
export function agentAnswersInList(cfg, chat) {
  const { mode = 'off', contacts = [], blocked = [], since = null, channelPaused = false } = cfg || {};
  const ref = String((chat && chat.ref) || '').trim();
  if (!ref || channelPaused) return false;
  if (ACTIVE_MODES.includes(mode)) {
    if ((blocked || []).some((c) => sameKey(c, ref))) return false;
    if ((contacts || []).some((c) => sameKey(c, ref))) return true;
    return !predatesSince(chat && chat.createdAt, since);
  }
  return (contacts || []).some((c) => sameKey(c, ref));
}
